<h1 fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="5px" mat-dialog-title>
	<div>{{data?.access === 2 ? 'Manage' : 'View'}} Attachments</div>
	<button color="primary" mat-dialog-close mat-icon-button>
		<mat-icon>close</mat-icon>
	</button>
</h1>
<app-attachments-drag-drop (refreshData)="setRefreshData($event)" [access]="data?.access"
						   [dialog]="dialogRef"
						   [workOrder]="data?.workorder"></app-attachments-drag-drop>
<mat-dialog-actions fxLayoutAlign="end">
	<button [color]="'accent'" [mat-dialog-close]="refreshData" mat-raised-button>
		<span>{{'errorModal.closeButton' | translate}}</span>
	</button>
</mat-dialog-actions>
